import { inject, Injectable } from '@angular/core';
import { CONFIG } from '../config/config.token';

@Injectable({
  providedIn: 'root',
})
export class ModuleService {
  private readonly config = inject(CONFIG);
  private readonly enabledModules = new Set(this.config.enabledModule);

  isModuleEnabled(moduleName: string): boolean {
    if (this.enabledModules.has('ALL')) {
      return true;
    }
    return this.enabledModules.has(moduleName);
  }
}
